module.exports = __webpack_public_path__ + "like.3ac7e9fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/articles/like.png
// module id = 3051
// module chunks = 0